<template id="modal-template">
    <div>
        <transition v-if="show" name="modal">
            <div class="modal-container">
                <div class="modal-wrapper">
                    <div class="modal">
                        <v-btn color="primary" icon @click="close" class="modal__close">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <div class="modal__body">
                            <div class="d-flex justify-center">
                                <youtube v-if="img.meta.youtube" :video-id="videoId" />
                                <v-img v-else :src=img.thumb class="w-100"></v-img>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>


<script>
import urlParser from "js-video-url-parser";

export default {
    components: {
    },
    props: {
        img: { type: Object },
    },
    data() {
        return {
            show: false,
            videoId: "",
        };
    },
    mounted() {
        console.log(this.$props.img, "dd");
        this.videoId = urlParser.parse(this.img.meta?.youtube)?.id || "";
    },
    methods: {
        open(){
            this.show = true;
        },
        close(){
            this.show = false;
        },
        
    },
    computed: {
    }
}
</script>
<style lang="scss" scoped>
@import "@/styles/_variables.scss";


</style>